module.exports = __webpack_public_path__ + "static/media/errorIcon.d1cc6108.svg";